import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef, useRef, useEffect } from 'react';
import { useInputMask } from '@indriver/nova-core';
import { Input } from '../input/input.js';

var _excluded = ["InputView", "maskConfig", "onChange", "value"];

function InputMaskGeneric(_ref, ref) {
  var _ref$InputView = _ref.InputView,
      InputView = _ref$InputView === void 0 ? Input : _ref$InputView,
      maskConfig = _ref.maskConfig,
      onChange = _ref.onChange,
      originalValue = _ref.value,
      inputProps = _objectWithoutPropertiesLoose(_ref, _excluded);

  var inputRef = useRef(null);
  useInputMask({
    maskConfig: maskConfig,
    onChange: onChange,
    originalValue: originalValue
  }, inputRef);
  useEffect(function () {
    if (!ref) {
      return;
    }

    if (typeof ref === 'function') {
      ref(inputRef.current);
    } else {
      // @ts-ignore:next-line
      ref.current = inputRef.current;
    }
  }, [ref]);
  return /*#__PURE__*/React__default.createElement(InputView, _extends({
    ref: inputRef
  }, inputProps));
}

InputMaskGeneric.displayName = 'InputMask';
var InputMask = /*#__PURE__*/forwardRef(InputMaskGeneric);

export { InputMask, InputMask as default };
